module.exports = __webpack_public_path__ + "static/media/plus.41d1b2f6.svg";